module.exports = __webpack_public_path__ + "img/items.e87d1bfc.png";